/* ============================================================
   Gǔ JEWELLERY — Immersive homepage  (v9 — fixed stage, event-driven)
   ------------------------------------------------------------
   ONE truth: no scroll-position driven state. Body scroll is
   locked while immersive is active; wheel + touch + keyboard
   events each advance ONE state. Closing CTA is state 4 INSIDE
   the fixed stage, not a section below. Native scroll is only
   allowed after the visitor has stepped past the closing state
   with an explicit gesture.

   STATES:  0 Opening → 1 Bespoke → 2 Evergreen → 3 Seasonal → 4 Closing
   ============================================================ */
(function () {
  'use strict';

  var STATES = ['opening', 'bespoke', 'evergreen', 'seasonal', 'closing'];
  var STATE_COUNT = STATES.length;

  var LOCK_MS       = 950;    // no re-advance until this elapses
  var WHEEL_THRESHOLD = 40;
  var TOUCH_THRESHOLD = 65;
  var TOUCH_MAX_MS  = 900;

  var HEADER_SELECTORS = [
    '.section-header', '.shopify-section-group-header-group',
    '#shopify-section-header', '#shopify-section-sections--header',
    '.shopify-section-header', '.header-wrapper',
    'header.header', 'header[role="banner"]', 'header'
  ];

  var d = {
    stage:       null,
    scenes:      [],
    bgEls:       {},
    dots:        null,
    openingCue:  null,
    tone:        null,
    valleyTone:  null,
    state:       0,
    locked:      false,
    released:    false,
    boundInput:  false
  };

  var _wheelAccum = 0;
  var _wheelTimer = null;
  var _touchStart = null;
  var _touchTime  = 0;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector('[data-gu-stage]')) removeBodyClasses();
  });

  function boot() {
    setVhVar();
    var stage = document.querySelector('[data-gu-stage]');
    if (!stage) {
      // Not on the immersive page — strip any stale immersive body classes
      removeBodyClasses();
      return;
    }

    d.stage       = stage;
    d.scenes      = Array.prototype.slice.call(stage.querySelectorAll('[data-gu-scene]'));
    STATES.forEach(function (k) { d.bgEls[k] = stage.querySelector('[data-gu-bg-' + k + ']'); });
    d.openingCue  = stage.querySelector('[data-gu-opening-cue]');
    d.tone        = stage.querySelector('[data-gu-tone]');
    d.valleyTone  = stage.querySelector('[data-gu-valley-tone]');
    d.dots        = document.querySelectorAll('[data-gu-dot]');

    document.body.classList.add('gu-immersive-home');
    document.body.classList.add('gu-im-hide-header');
    document.body.classList.add('gu-im-locked');
    try { window.scrollTo(0, 0); } catch (e) {}

    stage.querySelectorAll('[data-gu-gallery]').forEach(initGallery);
    initMobileMenu();
    initCtaTaps();

    fixStickyAncestors(stage);
    injectHeaderCss();
    applyState(true);
    bindInput();

    window.addEventListener('resize', setVhVar);
    window.addEventListener('orientationchange', setVhVar);
  }

  function setVhVar() {
    document.documentElement.style.setProperty('--gu-vh', (window.innerHeight * 0.01) + 'px');
  }
  function removeBodyClasses() {
    document.body.classList.remove(
      'gu-im-locked', 'gu-im-released', 'gu-im-hide-header',
      'gu-immersive-home', 'gu-im-closing-open', 'gu-im-mobile-lock',
      'gu-im-show-dots'
    );
  }

  /* ---------- Discrete state application ---------- */
  function applyState(isBoot) {
    var s = d.state;

    d.scenes.forEach(function (el) {
      var idx = STATES.indexOf(el.getAttribute('data-gu-scene'));
      var isActive = (idx === s);
      el.classList.toggle('is-active',     isActive);
      el.classList.toggle('is-visible',    isActive);
      el.classList.toggle('is-gallery-in', isActive);
      el.style.pointerEvents = isActive ? 'auto' : 'none';
    });

    // Backgrounds stacked Opening on top → each fades to reveal the next.
    // Closing state has its own solid-forest background layer.
    STATES.forEach(function (key, i) {
      var el = d.bgEls[key];
      if (!el) return;
      el.style.opacity = (i < s) ? '0' : '1';
    });

    if (d.tone)       d.tone.style.opacity       = (s === 0) ? '1' : '0';
    if (d.valleyTone) d.valleyTone.style.opacity = (s > 0 && s < 4) ? '1' : '0';
    if (d.openingCue) d.openingCue.style.opacity = (s === 0) ? '1' : '0';

    // Journey dots — only during Bespoke/Evergreen/Seasonal (states 1-3)
    if (d.dots && d.dots.length) {
      d.dots.forEach(function (dot) {
        var dotIdx = parseInt(dot.getAttribute('data-gu-dot'), 10);
        dot.classList.toggle('is-active', dotIdx === s);
      });
      document.body.classList.toggle('gu-im-show-dots', s >= 1 && s <= 3);
    }

    // Closing state class — flips the whole scene to the deep-forest CTA
    document.body.classList.toggle('gu-im-closing-open', s === 4);

    if (isBoot) return;
    d.locked = true;
    setTimeout(function () { d.locked = false; }, LOCK_MS);
  }

  function tryAdvance(dir) {
    if (d.locked) return;
    var next = d.state + dir;

    // Past Closing → release ON DESKTOP ONLY.
    // On mobile, Closing is the final state — do nothing, no release,
    // no footer reveal, no white background leak.
    if (next >= STATE_COUNT) {
      if (window.innerWidth <= 900) return;
      releaseImmersive();
      return;
    }
    // Before Opening → do nothing (Opening is the top)
    if (next < 0) return;

    d.state = next;
    applyState(false);
  }

  function releaseImmersive() {
    if (d.released) return;
    d.released = true;
    document.body.classList.remove('gu-im-locked');
    document.body.classList.add('gu-im-released');
    // Land the visitor on the first pixel of the theme's footer
    setTimeout(function () {
      try {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      } catch (e) { window.scrollTo(0, window.innerHeight); }
    }, 40);
    // Watch for scroll back to top → re-enter at Closing state
    window.addEventListener('scroll', maybeReenter, { passive: true });
  }

  function maybeReenter() {
    if (!d.released) return;
    if (window.scrollY < 8) {
      d.released = false;
      document.body.classList.remove('gu-im-released');
      document.body.classList.add('gu-im-locked');
      d.state = STATE_COUNT - 1;   // land at Closing, one gesture away from Seasonal
      applyState(true);            // no lock — visitor should be able to swipe immediately
      window.removeEventListener('scroll', maybeReenter);
    }
  }

  /* ---------- Input ---------- */
  function onWheel(e) {
    if (d.released) return;
    e.preventDefault();
    _wheelAccum += e.deltaY;
    if (_wheelTimer) clearTimeout(_wheelTimer);
    _wheelTimer = setTimeout(function () { _wheelAccum = 0; }, 180);
    if (!d.locked && Math.abs(_wheelAccum) > WHEEL_THRESHOLD) {
      var dir = _wheelAccum > 0 ? 1 : -1;
      _wheelAccum = 0;
      tryAdvance(dir);
    }
  }
  var _touchOnInteractive = false;
  function onTouchStart(e) {
    if (d.released) return;
    var t = e.target;
    // Tap on a REAL link/button = let the browser handle the click,
    // do not treat the gesture as a Valley swipe candidate at all.
    _touchOnInteractive = !!(t && t.closest && t.closest(
      'a[href], button, .gu-im-discover, .gu-im-closing__cta, .gu-im-mobile-menu, .gu-im-menu__close, .gu-im-menu__nav a, .gu-im-nav__logo, .gu-im-nav__icon'
    ));
    _touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    _touchTime  = Date.now();
  }
  function onTouchMove(e) {
    if (d.released) return;
    if (!_touchStart || _touchOnInteractive) return;
    var dy = e.touches[0].clientY - _touchStart.y;
    var dx = e.touches[0].clientX - _touchStart.x;
    // Only cancel default once movement is clearly a deliberate vertical swipe
    if (Math.abs(dy) > 15 && Math.abs(dy) > Math.abs(dx) * 0.9) {
      if (e.cancelable) e.preventDefault();
    }
  }
  function onTouchEnd(e) {
    var wasInteractive = _touchOnInteractive;
    _touchOnInteractive = false;
    if (d.released || !_touchStart || wasInteractive) { _touchStart = null; return; }
    if (document.body.classList.contains('gu-im-menu-open')) { _touchStart = null; return; }
    var dt = Date.now() - _touchTime;
    var dx = e.changedTouches[0].clientX - _touchStart.x;
    var dy = e.changedTouches[0].clientY - _touchStart.y;
    _touchStart = null;
    if (dt > TOUCH_MAX_MS) return;
    if (Math.abs(dy) < TOUCH_THRESHOLD) return;
    if (Math.abs(dx) > Math.abs(dy) * 0.9) return;
    if (d.locked) return;
    var dir = dy < 0 ? 1 : -1;
    tryAdvance(dir);
  }
  function onKey(e) {
    if (d.released) return;
    if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') {
      e.preventDefault(); tryAdvance(1);
    } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
      e.preventDefault(); tryAdvance(-1);
    }
  }
  function bindInput() {
    if (d.boundInput) return;
    d.boundInput = true;
    window.addEventListener('wheel',      onWheel,      { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true  });
    window.addEventListener('touchmove',  onTouchMove,  { passive: false });
    window.addEventListener('touchend',   onTouchEnd,   { passive: true  });
    window.addEventListener('keydown',    onKey);
  }

  /* ---------- Gallery ---------- */
  function initGallery(row) {
    if (row.__guGalleryBound) return;
    row.__guGalleryBound = true;
    var cards = Array.prototype.slice.call(row.querySelectorAll('.gu-im-card, .gu-v-card'));
    if (!cards.length) return;
    var activeIndex = Math.floor(cards.length / 2);
    var hoverLocked = false;
    var lockTimer   = null;

    function setActive(i) {
      activeIndex = Math.max(0, Math.min(cards.length - 1, i));
      cards.forEach(function (c, idx) {
        c.classList.remove('is-prev', 'is-active', 'is-next');
        if (idx === activeIndex)          c.classList.add('is-active');
        else if (idx === activeIndex - 1) c.classList.add('is-prev');
        else if (idx === activeIndex + 1) c.classList.add('is-next');
      });
    }
    cards.forEach(function (card, i) {
      card.addEventListener('mouseenter', function () {
        if (hoverLocked || i === activeIndex) return;
        setActive(i);
      });
      card.addEventListener('click', function (e) {
        if (i !== activeIndex) {
          e.preventDefault();
          setActive(i);
          hoverLocked = true;
          if (lockTimer) clearTimeout(lockTimer);
          lockTimer = setTimeout(function () { hoverLocked = false; }, 400);
        }
      });
    });
    // Horizontal swipe only — vertical falls through to state machine
    var tStart = null;
    row.addEventListener('touchstart', function (e) {
      tStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    row.addEventListener('touchend', function (e) {
      if (!tStart) return;
      var dx = e.changedTouches[0].clientX - tStart.x;
      var dy = e.changedTouches[0].clientY - tStart.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        setActive(activeIndex + (dx < 0 ? 1 : -1));
      }
      tStart = null;
    }, { passive: true });
    setActive(activeIndex);
  }

  /* ---------- Discover CTA taps ----------
     Delegated at the DOCUMENT level with capture=true so we intercept
     the touch BEFORE any other handler (including the global mobile
     swipe capture) can consume it. `closest('.gu-im-discover')` walks
     up from whichever element iOS reports as the target — the label
     span, the arrow span, or the anchor itself — so the tap always
     resolves to the anchor's href. */
  var _ctaTap = null;
  function onDocTouchStartCapture(e) {
    var t = e.target;
    var cta = t && t.closest && t.closest('.gu-im-discover, .gu-im-closing__cta');
    if (!cta) { _ctaTap = null; return; }
    _ctaTap = {
      cta: cta,
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      t: Date.now()
    };
  }
  function onDocTouchEndCapture(e) {
    if (!_ctaTap) return;
    var tap = _ctaTap;
    _ctaTap = null;
    var dx = Math.abs(e.changedTouches[0].clientX - tap.x);
    var dy = Math.abs(e.changedTouches[0].clientY - tap.y);
    var dt = Date.now() - tap.t;
    if (dx > 14 || dy > 14 || dt > 800) return;
    var href = tap.cta.getAttribute('href');
    if (!href) return;
    if (tap.cta.getAttribute('target') === '_blank') {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.href = href;
    }
  }
  function onDocClickCapture(e) {
    // Fallback for desktop / assistive tech: any click inside a CTA
    // navigates immediately, whichever descendant was targeted.
    var t = e.target;
    var cta = t && t.closest && t.closest('.gu-im-discover, .gu-im-closing__cta');
    if (!cta) return;
    var href = cta.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    e.stopPropagation();
    if (cta.getAttribute('target') === '_blank') {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.href = href;
    }
  }
  function initCtaTaps() {
    if (document.__guCtaTapsBound) return;
    document.__guCtaTapsBound = true;
    document.addEventListener('touchstart', onDocTouchStartCapture, { capture: true, passive: true });
    document.addEventListener('touchend',   onDocTouchEndCapture,   { capture: true, passive: true });
    document.addEventListener('click',      onDocClickCapture,      { capture: true });
  }

  /* ---------- Mobile hamburger drawer ---------- */
  function initMobileMenu() {
    var opener = document.querySelector('[data-gu-menu-open]');
    var closer = document.querySelector('[data-gu-menu-close]');
    var menu   = document.querySelector('[data-gu-menu]');
    if (!menu) return;
    if (opener) opener.addEventListener('click', function () {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gu-im-menu-open');
    });
    if (closer) closer.addEventListener('click', function () {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gu-im-menu-open');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('is-open');
        document.body.classList.remove('gu-im-menu-open');
      });
    });
  }

  /* ---------- Utilities ---------- */
  function fixStickyAncestors(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var cs = window.getComputedStyle(node);
      var patch = {};
      if (cs.overflow    && cs.overflow    !== 'visible') patch.overflow    = 'visible';
      if (cs.overflowX   && cs.overflowX   !== 'visible') patch.overflowX   = 'clip';
      if (cs.overflowY   && cs.overflowY   !== 'visible') patch.overflowY   = 'visible';
      if (cs.transform   && cs.transform   !== 'none')    patch.transform   = 'none';
      if (cs.filter      && cs.filter      !== 'none')    patch.filter      = 'none';
      if (cs.perspective && cs.perspective !== 'none')    patch.perspective = 'none';
      if (cs.contain     && cs.contain     !== 'none')    patch.contain     = 'none';
      Object.keys(patch).forEach(function (k) {
        node.style.setProperty(
          k.replace(/[A-Z]/g, function (c) { return '-' + c.toLowerCase(); }),
          patch[k], 'important'
        );
      });
      node = node.parentElement;
    }
  }
  function injectHeaderCss() {
    if (document.getElementById('gu-im-header-css')) return;
    var hide = HEADER_SELECTORS.map(function (s) { return 'body.gu-im-hide-header ' + s; }).join(', ');
    var anim = HEADER_SELECTORS.map(function (s) { return 'body ' + s; }).join(', ');
    var css = document.createElement('style');
    css.id = 'gu-im-header-css';
    css.textContent =
      anim + ' { transition: opacity 0.5s ease; }' +
      hide + ' { opacity: 0 !important; pointer-events: none !important; position: absolute !important; top: 0 !important; left: 0 !important; right: 0 !important; height: 0 !important; min-height: 0 !important; overflow: hidden !important; z-index: 1 !important; }';
    document.head.appendChild(css);
  }
})();
